import * as Rx from "rxjs"
import { retry, switchMap } from "rxjs/operators"
import type { OperationsBatch, SendOperationsResponse } from "../components/operations/types"
import { request } from "../utils/http"

export const sendOperations = (
    headers: Record<string, any>,
    operationsToSend: OperationsBatch
): Rx.Observable<SendOperationsResponse> =>
    Rx.from(
        request({
            method: "PUT",
            path: "/data/operation",
            headers: { ...headers, "Content-Type": "application/json" },
            body: {
                content: [operationsToSend],
            },
        })
    ).pipe(
        retry(3),
        switchMap(result =>
            result && result instanceof Array && result.length > 0
                ? Rx.of(result[0])
                : Rx.throwError(() => new Error("Operation Failed"))
        )
    )
